import React from "react";
import Economy from "us.collection.economy";
import { Route } from "react-router-dom";
import {
  MainSearch,
  UserRoleSettings,
  UserSettings,
  Home
} from "./asyncRoutes";

export default (caseNo: number) => {
  const MainViewModules = [Economy];

  return [
    <Route
      key="search"
      path={"/search"}
      element={<MainSearch />}
    />,
    <Route
      key="/"
      path={"/"}
      element={<Home />}
    />,
    ...MainViewModules.map(({ Routes }) => Routes.asyncRoutes),
  ];
};
